import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BarcodeParserService } from './barcode-parser.service';
import { BarcodeParser } from './barcode-parser';
import { Ean13RusParser } from './barcode-parsers/ean13RusParser';

@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [
    {
      provide: BarcodeParser,
      useExisting: Ean13RusParser,
      multi: true,
    },
    BarcodeParserService,
  ],
})
export class BarcodeParserModule {}
